import { mergeStyles, convertToLocalStyle, actionDropdownStyles } from '@bingads-webui-campaign-react/common-styles';

export const getStyles = (components, theme) => ({
  callToActionContainer: {
    ...mergeStyles(
      { theme },
      convertToLocalStyle(actionDropdownStyles(theme, { dropdownMinWidthPx: 281, noLeftMargin: true })),
      components.searchboxStyle
    ),
  },
  languageContainer: {
    ...mergeStyles(
      { theme },
      convertToLocalStyle(actionDropdownStyles(theme, { dropdownMinWidthPx: 281, noLeftMargin: true }))
    ),

    '& .actionextension-search-dropdown-container .dropdown-menu': {
      top: 'unset',
    },

    marginBottom: '15px',
  },
});
